import { render, staticRenderFns } from "./AmInput.vue?vue&type=template&id=2b7bbd33&scoped=true&"
import script from "./AmInput.vue?vue&type=script&lang=js&"
export * from "./AmInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7bbd33",
  null
  
)

export default component.exports